import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    ListGroup,
    Col,
    Panel
} from 'react-bootstrap';
import config from '../config.js';
import { invokeApig } from '../libs/awsLib';
import CustomListGroupItem from '../components/CustomListGroupItem';
import './Admin.css';

class Admin extends Component {
  constructor(props) {
    super(props);

    this.state = {
        isLoading: false,
        customers: [],
    };
  }
  
    async componentDidMount() {
      this.setState({ isLoading: true });
      try {
        var customers = await this.customers();
        this.setState({ customers: customers});
      }
      catch(e) {
        alert(e);
      }
      this.setState({ isLoading: false });
    }

    async customers() {
      var token = await this.props.getUserToken();
      return invokeApig({ path: '/admin/customers' },  token);
    }

    async deleteCustomer(customerId, userId) {
      var token = await this.props.getUserToken();
      return invokeApig({
          path: `/admin/customers/${customerId}/user/${userId}`,
          method: 'DELETE',
      }, token);
    }

    handleDeleteCustomer = async (customerId, userId, customerIndex, event) => {
        event.preventDefault();
        event.stopPropagation();

        const confirmed = window.confirm('Are you sure you want to delete "' + customerIndex + '" customer?\n\n' +
          'This action cannot be undone and will delete all data permanently!');

        if ( ! confirmed) {
            return;
        }

        try {
          await this.deleteCustomer(customerId, userId);
          var customers = await this.customers();
          this.setState({ customers: customers});
        }
        catch(e) {
            alert(e);
        }
    }

    handleCustomerClick = (event) => {
        event.preventDefault();
    }

  render() {
    return(
      <div className="Customers">
        <Col xs={16} md={8} >
          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h2">Your Customer List</Panel.Title>
            </Panel.Heading>
            <ListGroup>
              {
                [{}].concat(this.state.customers).map((customer, i) => (
                  i !== 0
                  ? ( <CustomListGroupItem
                      key={customer.customerId}
                      href={`/admin`}
                      onClick={this.handleCustomerClick}
                      leftImage="/user-4-32-b.png"
                      Title={customer.customerIndex + " user: " + customer.userId}
                      createdDate={(new Date(customer.createdAt)).toLocaleString()}
                      titleCustom="Splunk Admin"
                      handleCustom={(evt) => {evt.preventDefault(); evt.stopPropagation(); window.open(`${config.externalURL.splunkURL}/${customer.customerId}/en-US/account/login?loginType=splunk`, "_blank");}}
                      handleDelete={(evt) => this.handleDeleteCustomer(customer.customerId, customer.userId, customer.customerIndex, evt)}
                    /> )
                  : ( <br/>)
                ))
              }
            </ListGroup>
          </Panel>
        </Col>
        <Col xs={16} md={4} >
          <Panel>
            <Panel.Heading>
              <Panel.Title componentClass="h2">Overall Status</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              Not Implemented
            </Panel.Body>
          </Panel>
        </Col>
      </div>
    )
  }
}

export default withRouter(Admin);


// WEBPACK FOOTER //
// ./src/containers/Admin.js